// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Responsive Layout */
.App {
  display: flex;
  height: 100vh;
  flex-direction: column;
}

.left-side,
.right-side {
  box-sizing: border-box;
}

.loading {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.loading svg polyline {
  fill: none;
  stroke-width: 2;
  stroke-linecap: round;
  stroke-linejoin: round;
}

.loading svg polyline#back {
  stroke: rgba(255, 106, 0, 0.241);
}

.loading svg polyline#front {
  stroke: #ff7700;
  stroke-dasharray: 12, 36;
  stroke-dashoffset: 48;
  animation: dash 1s linear infinite;
}

/* Animation */
@keyframes dash {
  62.5% {
    opacity: 0;
  }
  to {
    stroke-dashoffset: 0;
  }
}

/* Responsive media queries */
@media (max-width: 600px) {
  .App {
    flex-direction: column;
  }

  .left-side {
    width: 100%;
    padding: 10px;
  }

  .right-side {
    width: 100%;
    padding: 10px;
  }
}

@media (min-width: 600px) {
  .left-side {
    width: 30%;
    max-width: 320px;
    padding: 10px;
  }

  .right-side {
    width: 70%;
    padding: 10px;
  }
}

.unzipping {
  width: 80px;
  height: 80px;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
}

.unzipping::before,
.unzipping::after {
  content: '';
  position: absolute;
  width: 60px;
  height: 5px;
  background-color: rgb(255, 123, 0);
  animation: unzip-line 1s infinite alternate;
}

.unzipping::after {
  transform: rotate(90deg);
  animation-delay: 0.5s;
}

@keyframes unzip-line {
  from {
    width: 0;
  }
  to {
    width: 60px;
  }
}

.gifanimation {
  width: 10vw;
  height: 10vw;
  max-width: 200px;
  max-height: 200px;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
}


.responsive-svg {
  max-height: 60px; 
  min-height: 30px;  
  width: 100%;
}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA,sBAAsB;AACtB;EACE,aAAa;EACb,aAAa;EACb,sBAAsB;AACxB;;AAEA;;EAEE,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,eAAe;EACf,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,wBAAwB;EACxB,qBAAqB;EACrB,kCAAkC;AACpC;;AAEA,cAAc;AACd;EACE;IACE,UAAU;EACZ;EACA;IACE,oBAAoB;EACtB;AACF;;AAEA,6BAA6B;AAC7B;EACE;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;IACX,aAAa;EACf;;EAEA;IACE,WAAW;IACX,aAAa;EACf;AACF;;AAEA;EACE;IACE,UAAU;IACV,gBAAgB;IAChB,aAAa;EACf;;EAEA;IACE,UAAU;IACV,aAAa;EACf;AACF;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;;EAEE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,kCAAkC;EAClC,2CAA2C;AAC7C;;AAEA;EACE,wBAAwB;EACxB,qBAAqB;AACvB;;AAEA;EACE;IACE,QAAQ;EACV;EACA;IACE,WAAW;EACb;AACF;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;;AAGA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,WAAW;AACb","sourcesContent":["/* Responsive Layout */\n.App {\n  display: flex;\n  height: 100vh;\n  flex-direction: column;\n}\n\n.left-side,\n.right-side {\n  box-sizing: border-box;\n}\n\n.loading {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n}\n\n.loading svg polyline {\n  fill: none;\n  stroke-width: 2;\n  stroke-linecap: round;\n  stroke-linejoin: round;\n}\n\n.loading svg polyline#back {\n  stroke: rgba(255, 106, 0, 0.241);\n}\n\n.loading svg polyline#front {\n  stroke: #ff7700;\n  stroke-dasharray: 12, 36;\n  stroke-dashoffset: 48;\n  animation: dash 1s linear infinite;\n}\n\n/* Animation */\n@keyframes dash {\n  62.5% {\n    opacity: 0;\n  }\n  to {\n    stroke-dashoffset: 0;\n  }\n}\n\n/* Responsive media queries */\n@media (max-width: 600px) {\n  .App {\n    flex-direction: column;\n  }\n\n  .left-side {\n    width: 100%;\n    padding: 10px;\n  }\n\n  .right-side {\n    width: 100%;\n    padding: 10px;\n  }\n}\n\n@media (min-width: 600px) {\n  .left-side {\n    width: 30%;\n    max-width: 320px;\n    padding: 10px;\n  }\n\n  .right-side {\n    width: 70%;\n    padding: 10px;\n  }\n}\n\n.unzipping {\n  width: 80px;\n  height: 80px;\n  position: relative;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.unzipping::before,\n.unzipping::after {\n  content: '';\n  position: absolute;\n  width: 60px;\n  height: 5px;\n  background-color: rgb(255, 123, 0);\n  animation: unzip-line 1s infinite alternate;\n}\n\n.unzipping::after {\n  transform: rotate(90deg);\n  animation-delay: 0.5s;\n}\n\n@keyframes unzip-line {\n  from {\n    width: 0;\n  }\n  to {\n    width: 60px;\n  }\n}\n\n.gifanimation {\n  width: 10vw;\n  height: 10vw;\n  max-width: 200px;\n  max-height: 200px;\n  position: relative;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n\n.responsive-svg {\n  max-height: 60px; \n  min-height: 30px;  \n  width: 100%;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
